import React, { useState, useRef, useEffect } from "react";
import styles from "./index.module.css";
import arrowUP from "../../../assets/arrowUp.png";
import arrowDown from "../../../assets/arrowDown.png";

const genderOptions = [
    { value: "Male", text: "Male" },
    { value: "Female", text: "Female" },
    { value: "Non-binary", text: "Non-binary" }
];

const DropDown = ({ setGender, gender }) => {
    const [dropDown, setDropDown] = useState(false);
    const dropdownRef = useRef(null);

    const handleDropDownToggle = () => {
        setDropDown(!dropDown);
    };

    const handleSelectGender = (gender) => {
        setGender(gender.value);
        setDropDown(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropDown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={styles.dropDownContainer}>
            <div className={styles.dropDown} ref={dropdownRef}>
                <div className={styles.dropDownHeader} onClick={handleDropDownToggle}>
                    <div className={styles.selectedValue}>{gender}</div>
                    <img src={dropDown ? arrowUP : arrowDown} className={styles.arrow} alt="down" />
                </div>

                <div className={`${styles.dropDownContent} ${dropDown ? styles.dropDownContentVisible : styles.dropDownContentHidden}`}>
                    {genderOptions.map((option, index) => (
                        <div key={index} className={styles.dropDownItem} onClick={() => handleSelectGender(option)}>
                            <div className={styles.genderText}>{option.text}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DropDown;
